<template>
    <div class="search-widget-embed">
        <HotelSearch :showSearchWidget="true" :iframeWidget="true" />
    </div>
</template>

<script>
import HotelSearchWidget from '@/components/hotels/HotelSearchWidget'

export default {
    data () {
        return {

        }
    },

    components: {
        'HotelSearch': HotelSearchWidget
    },

    mounted() {
        let style = document.createElement('style');
        style.innerHTML = 'body { background: none; }';
        document.head.appendChild(style);
    },
    beforeDestroy() {
        let style = document.createElement('style');
        style.innerHTML = 'body { background-color: #f3f3f3; }'
        document.head.appendChild(style);
    }
}
</script>